export enum ComparisonScaleOptions {
  DISABLED = -1,
  CONTINUOUS = 0,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
}
